import { HttpClient, HttpParams } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Paginador } from "../api/dto/paginacao/paginador";
import { RelatorioCaixaTotalComanda } from "../api/dto/relatorio-caixa-total-comanda";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RelatorioCaixaService {


    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'relatorios-caixa/';

    consultarRelotorioTotaisComanda(empresaId?: number, data?: Date, status?: string,
        usuarioId?: number, inputBusca?: string,): Observable<RelatorioCaixaTotalComanda[]> {

        let params = new HttpParams();
        if (usuarioId) {
            params = params.set('usuarioId', usuarioId);
        }
        if (inputBusca) {
            params = params.set('busca', inputBusca);
        }

        return this.http.get<RelatorioCaixaTotalComanda[]>(this.url + "empresa/" + empresaId + "/data/" + data + "/status/"
            + status, { params });
    }

    consultarRelotorioTotaisComandaPaginado(empresaId?: number, data?: Date, status?: string,
        numeroPagina?: number, tamanhoPagina?: number, ordenacao?: string, inputBusca?: string, usuarioId?: number): Observable<Paginador<RelatorioCaixaTotalComanda>> {

        let params = new HttpParams();
        if (tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if (ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if (inputBusca) {
            params = params.set('busca', inputBusca);
        }
        if (usuarioId) {
            params = params.set('usuarioId', usuarioId);
        }

        return this.http.get<Paginador<RelatorioCaixaTotalComanda>>(this.url + "empresa/" + empresaId + "/data/" + data + "/status/"
            + status + '/numero-pagina/' + numeroPagina, { params });
    }


    gerarPdf(empresaId?: number, dataCaixa?: Date) {
        const url = `${this.url}caixa-completo/empresa/${empresaId}/data/${dataCaixa}`;
        return this.http.get(url, { responseType: 'blob' });
    }
}